module.exports = __webpack_public_path__ + "img/download-install-key.7c7e54f7.png";